const SIMULATED_CONVERSATIONS_PATH = "/simulated"
const UPLOADED_CONVERSATIONS_PATH = "/uploaded"

export function simulatedRunPath(runId: string): string {
  return `${SIMULATED_CONVERSATIONS_PATH}/runs/${encodeURIComponent(runId)}`
}

export function simulatedConversationPath(
  runId: string,
  simulationOutputId: string,
): string {
  return `${simulatedRunPath(runId)}/results/${encodeURIComponent(simulationOutputId)}`
}

export function uploadedConversationPath(simulationOutputId: string): string {
  return `${UPLOADED_CONVERSATIONS_PATH}/results/${encodeURIComponent(simulationOutputId)}`
}

/** Returns the canonical destination for a permanent conversation-route alias. */
export function canonicalConversationRoute(path: string): string | null {
  if (path === "/runs") {
    return SIMULATED_CONVERSATIONS_PATH
  }
  if (path.startsWith("/runs/")) {
    return `${SIMULATED_CONVERSATIONS_PATH}/runs${path.slice("/runs".length)}`
  }
  for (const legacyRoot of ["/conversations", "/monitoring"]) {
    if (path === legacyRoot) {
      return UPLOADED_CONVERSATIONS_PATH
    }
    if (path.startsWith(`${legacyRoot}/`)) {
      return `${UPLOADED_CONVERSATIONS_PATH}${path.slice(legacyRoot.length)}`
    }
  }
  return null
}
